import { Injectable } from '@angular/core';
import { ServiceService } from '@aex/shared/apis';
import { Observable } from 'rxjs';
import { IService } from '@aex/shared/common-lib';

@Injectable({
	providedIn: 'root',
})
export class ServiceDataService {

	constructor(
		private readonly serviceService: ServiceService,
	) {
	}

	public getService(serviceId: string): Observable<IService> {
		return this.serviceService.getService(serviceId);
	}
}
